// Routes owned by the Business module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const businessPaths = {
    businessesManage: '/businesses',
    businessAccountList: '/account/businesses',
    businessAccountDetail: '/account/businesses/:id',
    businessAccountCreate: '/account/businesses/new',
} as const
